import useEventHandler from './useEventHandler'
import useHeadingLevel from './useHeadingLevel'
import positionElement from './positionElement'
import elementAttributes from './elementAttributes'
import contains from './contains'
import { Icon, iconProps } from './Icon'
import Dropdown from './Dropdown'
import classNames from 'classnames'
import {
  findTheme,
  useGlobalId,
  useSetState,
  useTheme,
  useUpdateRef
} from './hooks'

export {
  classNames,
  contains,
  Dropdown,
  elementAttributes,
  findTheme,
  Icon,
  iconProps,
  positionElement,
  useEventHandler,
  useGlobalId,
  useHeadingLevel,
  useSetState,
  useTheme,
  useUpdateRef
}

export default {
  classNames,
  contains,
  Dropdown,
  elementAttributes,
  findTheme,
  Icon,
  iconProps,
  positionElement,
  useEventHandler,
  useGlobalId,
  useHeadingLevel,
  useSetState,
  useTheme,
  useUpdateRef
}
